export const UPDATE_FORM = "UPDATE_FORM";
export const READ_USER_DETAILS = "READ_USER_DETAILS";
export const USER_DETAILS_ERROR = "USER_DETAILS_ERROR";
export const CLEAR_USER_DETAILS = "CLEAR_USER_DETAILS";
export const START_USER_DETAILS_RELOAD = "START_USER_DETAILS_RELOAD";
export const FINISHED_USER_DETAILS_RELOAD = "FINISHED_USER_DETAILS_RELOAD";
export const CLEAR_USER_FORM = "CLEAR_USER_FORM";
export const READ_USERS = "READ_USERS";
